import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import TenorGif from '../../components/auth/TenorGif';

const LoginPage = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      setTimeout(() => {
        navigate('/dashboard', { replace: true });
      }, 100);
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen bg-gray-100">Loading...</div>;
  }

  if (isAuthenticated) {
    return <div className="flex items-center justify-center min-h-screen bg-gray-100">Redirecting...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-xs">
        <div className="bg-white rounded-lg shadow-md p-6 text-center">
          <h1 className="text-xl font-semibold text-gray-800 mb-4">
            Get Talky Admin Portal
          </h1>
          
          <div className="mx-auto mb-4 w-full aspect-video overflow-hidden rounded-lg">
            <TenorGif 
              postId="9563511110565717034"
              shareMethod="host"
              aspectRatio="1.777"
              width="100%"
            />
          </div>
          
          <button 
            className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded-md transition duration-200"
            onClick={() => loginWithRedirect()}
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 